import { KeyboardEvent, useEffect, useRef, useState } from "react";
import { titleMRClass } from "src/components/common/common";
import { formatDate } from "src/utils/string/stringUtil";
import { XButtonForm } from "../XButtonForm";

import useScreenStore from "src/store/useScreenStore";
import { handleKeyDown } from "src/utils/commonForm/commonFormUtils";

//주민등록번호 폼

interface Props {
  title?: string;
  forwardValue: string;
  backwardValue: string;
  editable: boolean;
  titleless?: boolean;
  name?: string;
  forwardOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  backwardOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  wrapperOption?: {
	wrapperStyle: string;
	titleStyle: string;
	inputStyle: string;
	registNumberStyle: string;
  };
  maxLength?: number;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  onLoadFocus?: boolean;
}

interface StyleSet {
	wrapperStyle: string;
	titleStyle: string;
	inputStyle: string;
	registNumberStyle: string;
}

export const KRegistNumberForm = (props: Props) => {

	const { 
		title,
		forwardValue,
		backwardValue,
		editable,
		titleless = false,
		name,
		forwardOnChange,
		backwardOnChange,
		wrapperOption = {
			wrapperStyle: "w-[350px] min-w-[350px] mr-[10px] mb-[5px]",
			titleStyle: "w-[150px] min-w-[150px]",
			inputStyle: "w-[70px] min-w-[70px]",
			registNumberStyle: "w-[70px] min-w-[70px]",
		},
		maxLength = 100,
		onLoadFocus = false,
	} = props;

	const forwardRef = useRef<HTMLInputElement>(null);
	const backwardRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (onLoadFocus) {
      forwardRef.current?.focus();
    }
  }, [onLoadFocus]);

	const initValue = (value: any) => {
		if(value === 'forwardValue') {
			forwardRef.current!.value = '';
		} else if(value === 'backwardValue') {
			backwardRef.current!.value = '';
		}
	}

	const forwardOnKeyDown = props.onKeyDown ?? ((e) => { handleKeyDown(e, 'focus'); });
	const backwardOnKeyDown = props.onKeyDown != null ? props.onKeyDown : handleKeyDown;

  return (
	// 20px : input 높이
	<div className={`flex h-[20px] ${wrapperOption.wrapperStyle}`}>
		{title && 
			<>
				<p	className={`${wrapperOption.titleStyle} form-title ${titleMRClass} cursor-pointer ${titleless ? 'hidden' : ''}`} 
					onClick={() => forwardRef.current?.focus()}
					onKeyDown={() => forwardRef.current?.focus()}
					tabIndex={ editable ? 0 : -1}
				>
					{title}
				</p>
				<div className={`relative ${wrapperOption.inputStyle}`}>
					<input
						className={`border-[1px] rounded-[4px] px-[2px] w-full
										${editable ? "bg-white" : "bg-gray-disable"}
										[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none
									`}
						ref={forwardRef}
						value={forwardValue} 
						disabled={!editable}
						name={name || ""}
						type="text"
						maxLength={maxLength}
						onChange={forwardOnChange}
						onKeyDown={forwardOnKeyDown}
					/>
						<XButtonForm onClick={() => {initValue('forwardValue');}} />
				</div>
				<div style={{width: '10px', textAlign: 'center'}}>{` - `}</div>
				<div className={`relative ${wrapperOption.registNumberStyle}`}>
					<input
						className={`border-[1px] rounded-[4px] px-[2px] w-full
										${editable ? "bg-white" : "bg-gray-disable"}
										[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none
									`}
						ref={backwardRef}
						value={backwardValue} 
						disabled={!editable}
						name={name || ""}
						type="text"
						maxLength={maxLength}
						onChange={backwardOnChange}
						onKeyDown={backwardOnKeyDown}
					/>
					<XButtonForm onClick={() => {initValue('backwardValue');}} />
				</div>
			</>
		}
	</div>
  )

}